__turbopack_context__.v({
  "disabled": "RightMouseClickMenu-module-scss-module__PE0hQG__disabled",
  "divider": "RightMouseClickMenu-module-scss-module__PE0hQG__divider",
  "iconWrapper": "RightMouseClickMenu-module-scss-module__PE0hQG__iconWrapper",
  "menu": "RightMouseClickMenu-module-scss-module__PE0hQG__menu",
  "menuItem": "RightMouseClickMenu-module-scss-module__PE0hQG__menuItem",
  "wrapper": "RightMouseClickMenu-module-scss-module__PE0hQG__wrapper",
});
